import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { getImageWithFallback } from '../../config/images';

const SafeImage = ({
    src,
    alt,
    contentType = 'session',
    category = null,
    fallbackImage = null,
    width = '100%',
    height = 'auto',
    sx = {},
    showSkeleton = true,
    onLoad,
    onError,
    ...props
}) => {
    const [imageSrc, setImageSrc] = useState(() =>
        getImageWithFallback(src, contentType, category)
    );
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const handleLoad = () => {
        setIsLoading(false);
        setHasError(false);
        if (onLoad) onLoad();
    };

    const handleError = () => {
        setIsLoading(false);
        setHasError(true);

        // Essayer l'image de fallback personnalisée d'abord
        if (fallbackImage && fallbackImage !== imageSrc) {
            setImageSrc(fallbackImage);
            setIsLoading(true);
            return;
        }

        // Sinon, utiliser l'image par défaut du système
        const defaultImage = getImageWithFallback(null, contentType, category);
        if (defaultImage !== imageSrc) {
            setImageSrc(defaultImage);
            setIsLoading(true);
        }

        if (onError) onError();
    };

    return (
        <Box sx={{ position: 'relative', width, height, ...sx }}>
            {showSkeleton && isLoading && (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    animation="wave"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }}
                />
            )}

            <img
                src={imageSrc}
                alt={alt || 'Image'}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: isLoading ? 'none' : 'block',
                }}
                onLoad={handleLoad}
                onError={handleError}
                {...props}
            />

            {hasError && !isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'grey.200',
                        color: 'text.secondary',
                        fontSize: '0.875rem',
                    }}
                >
                    Image non disponible
                </Box>
            )}
        </Box>
    );
};

export default SafeImage;
